module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Upload-3da35455c107c5bbaeeead433006311f.svg";